import { isPortugalMarket } from '../config/marketRegion';

export function currencyCode(): 'EUR' | 'BRL' {
  return isPortugalMarket() ? 'EUR' : 'BRL';
}

export function currencySymbol(): string {
  return isPortugalMarket() ? '€' : 'R$';
}

export function amountFieldLabel(): string {
  return labeledAmount('Valor');
}

/** Sufixo entre parênteses: (R$) ou (€) */
export function currencyInParens(): string {
  return isPortugalMarket() ? '(€)' : '(R$)';
}

export function labeledAmount(base: string): string {
  return `${base} ${currencyInParens()}`;
}

export function formatHiddenCurrency(): string {
  return `${currencySymbol()} ••••••`;
}

export function formatMarketCurrency(value: number): string {
  const locale = isPortugalMarket() ? 'pt-PT' : 'pt-BR';
  return new Intl.NumberFormat(locale, { style: 'currency', currency: currencyCode() }).format(Number(value) || 0);
}

/** Valores nulos/indefinidos — ex.: tabelas DRE */
export function formatMarketCurrencyOrDash(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '–';
  return formatMarketCurrency(Number(value));
}

export function formatCompactCurrencyThousands(value: number): string {
  const n = Number(value) || 0;
  if (Math.abs(n) >= 1000) {
    const locale = isPortugalMarket() ? 'pt-PT' : 'pt-BR';
    const compact = (n / 1000).toLocaleString(locale, { maximumFractionDigits: 1 });
    return `${currencySymbol()} ${compact} mil`;
  }
  return formatMarketCurrency(n);
}
